function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,134.8c137.1,0,242.6,57.8,242.6,121.2S393,377.2,256,377.2c-137.1,0-242.6-57.8-242.6-121.2S119,134.8,256,134.8  M256,121.4C114.6,121.4,0,181.6,0,256s114.6,134.6,256,134.6S512,330.4,512,256S397.4,121.4,256,121.4z M174.6,245.2 c-6.3,32.4-28.6,29-56.1,29l11-56.5C159.8,217.8,180.5,214.5,174.6,245.2L174.6,245.2z M77.9,331.4h29.4l7-35.8 c32.9,0,53.3,2.4,72.2-15.3c20.9-19.2,26.3-53.4,11.4-70.5c-7.8-9-20.2-13.4-37.2-13.4h-56.6L77.9,331.4z M226.5,160.6h29.2l-7,35.8 c25.2,0,48.6-1.8,59.8,8.6c11.8,10.9,6.2,24.8-6.6,90.5h-29.6c12.3-63.5,14.6-68.8,10.2-73.6c-4.3-4.6-14.2-3.7-37.9-3.7l-15,77.3 h-29.2L226.5,160.6L226.5,160.6z M404,245.2c-6.4,32.9-29.4,29-56.1,29l11-56.5C389.4,217.8,409.9,214.5,404,245.2L404,245.2z  M307.4,331.4h29.4l7-35.8c34.6,0,53.7,2,72.2-15.3c20.9-19.2,26.3-53.4,11.4-70.5c-7.8-9-20.2-13.4-37.2-13.4h-56.6L307.4,331.4z"
});

function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.fd27e545.svg";
export { ForwardRef as ReactComponent };